/*
 * Design: Command Center — Dark Operations Dashboard
 * Single-page landing: Navbar, Hero, Services, Pulse System, AI Systems, Why Us, Testimonials, CTA, Footer
 * Background: #09090B (true dark), DM Sans typography
 */

import { useEffect, lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import PulseSection from "@/components/PulseSection";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";

// Lazy-load below-the-fold sections
const AISystemsSection = lazy(() => import("@/components/AISystemsSection"));
const WhyUsSection = lazy(() => import("@/components/WhyUsSection"));
const TestimonialsSection = lazy(() => import("@/components/TestimonialsSection"));

function SectionFallback() {
  return <div className="min-h-[400px] bg-[#09090B]" />;
}

export default function Home() {
  useEffect(() => {
    document.title = "The AI Assistant Lab | AI Systems & GHL Automation";
    // Add BreadcrumbList schema
    const breadcrumbScript = document.createElement('script');
    breadcrumbScript.type = 'application/ld+json';
    breadcrumbScript.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://info.theaiassistantlab.com"
        }
      ]
    });
    document.head.appendChild(breadcrumbScript);
  }, []);

  return (
    <div className="min-h-screen bg-[#09090B]">
      <Navbar />
      <HeroSection />
      <ServicesSection />
      <PulseSection />
      <Suspense fallback={<SectionFallback />}>
        <AISystemsSection />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <WhyUsSection />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <TestimonialsSection />
      </Suspense>
      <CTASection />
      <Footer />
    </div>
  );
}
